import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from 'src/app/services/shared/shared.service';
import { NavigationExtras, Router } from '@angular/router';
import { LabelService } from 'src/app/services/label/label.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { encodeURL } from 'src/app/services/parseURL';
@Component({
  selector: 'app-banner-slider',
  templateUrl: './banner-slider.component.html',
  styleUrls: ['./banner-slider.component.scss'],
})
export class BannerSliderComponent implements OnInit {
  @Input() banners: any;

  
  bannerSlideOpts = {
    initialSlide: 0,
    slidesPerView: 1,
    speed: 400,
    disableOnInteraction: false,
    autoplay:true,
    
  };
  SHOP_CATEGORIES_LABELS: any = {};
  SHARED_LABELS: any = {};
  searchPlaceholder = '';
  imgLoaded = false;
  popupData: any;
  BANNER_SETTINGS_LABELS: any;
  CO_CATEGORY_GRID_LABELS: any;
  RFQFeature = false;
  promoVideo: any;

  constructor( private utilsService:UtilsService,private sharedService: SharedService, private router: Router,private labelService:LabelService,
    private widgetsService: WidgetsService) { 

  }

  ngOnInit() {
    this.BANNER_SETTINGS_LABELS = this.labelService.labels['BANNER_SETTINGS'];
  }

  async onClickBanner(bannerData: any) {
    this.widgetsService.bannerLink(bannerData);
    
  }
  getUrlTxt(value: string) {
    return encodeURL(value);
  }

  

}
